import { http } from '@/api/client/httpClient';
import type {
  AnalyticsChartResultDto,
  AnalyticsFilterInput,
  AnalyticsResultDto,
  ConsolidatedAnalyticsResultDto,
  DtfTableDto,
} from '@/api/types/analytics';

const BASE = '/api/app/analytics';

export const analyticsApi = {
  // Calculate* / Export* are POST (ABP keeps non-Get verb prefixes); Get* are GET.
  calculateByLogin: (input: AnalyticsFilterInput) =>
    http.post<AnalyticsResultDto>(`${BASE}/calculate-performance-by-login`, input).then((r) => r.data),
  calculateByUniqueId: (input: AnalyticsFilterInput) =>
    http.post<ConsolidatedAnalyticsResultDto>(`${BASE}/calculate-performance-by-unique-id`, input).then((r) => r.data),
  getDtfTable: (input: AnalyticsFilterInput) =>
    http.get<DtfTableDto>(`${BASE}/dtf-table`, { params: input }).then((r) => r.data),
  getTop8ByVolume: (input: AnalyticsFilterInput) =>
    http.get<AnalyticsChartResultDto>(`${BASE}/top8Instruments-by-volume`, { params: input }).then((r) => r.data),
  getTop8ByNotional: (input: AnalyticsFilterInput) =>
    http.get<AnalyticsChartResultDto>(`${BASE}/top8Instruments-by-notional-value`, { params: input }).then((r) => r.data),
  exportToExcelUrl: `${BASE}/export-to-excel`,
};
